import {Component, Inject, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {take} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {IconViewModel, IconViewResponse, PermissionTypes} from '@features/file-manager/models/file-manager.model';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-move-item-dialog',
  templateUrl: './move-item-dialog.component.html',
  styleUrls: ['./move-item-dialog.component.scss']
})
export class MoveItemDialogComponent implements OnInit, IDialogView {
  queryName: string;
  pageSize = 50;
  isClientDrive = true;
  data: DialogModel;
  pageNo = 0;
  pageCount = 1;
  infiniteScrollDisabled = false;
  sourceFileIds: string[];
  iconViewResponse: IconViewResponse;
  copy = false;
  parentId: string;
  parentName: string;
  selectedItem: IconViewModel;
  canMove = false;
  canMoveBySelect = false;
  moveHere = 'Move Here';
  move = 'Move';


  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private platformQueryService: PlatformQueryService,
              protected snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public dialogInfo: DialogModel) {
  }

  ngOnInit(): void {
    this.parentId = this.data.input.data.parentId;
    this.parentName = this.data.input.data.parentName;
    this.isClientDrive = this.data.input.data.isClientDrive;
    this.sourceFileIds = this.data.input.data.sourceFiles;
    this.getItemList(this.parentId, this.pageNo);
    this.dialogInfo.okCaption = this.moveHere;
    this.dialogInfo.isDisabledOkButton = true;
  }

  getItemList(parentId: string, pageNo: number, parentName?: string) {
    const query = new PlatformQuery();
    query.name = 'IconViewQuery';
    if (this.queryName) {
      query.name = this.queryName;
    }
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues['ParentId'] = parentId;
    query.fieldValues['IsClientDrive'] = this.isClientDrive;
    query.fieldValues['PageSize'] = this.pageSize;
    query.fieldValues['PageNo'] = pageNo;
    query.fieldValues['FileExtensionTypes'] = [];
    query.fieldValues['HideFiles'] = true;
    query.fieldValues['IconType'] = 'medium';

    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      const iconViewResponse = response.fieldValues['IconViewResponse'];
      iconViewResponse.items = iconViewResponse.items.filter(o => {
        if ((o.type === 'SharedDrive' || o.type === 'SharedDrives' || o.type === 'PersonalDrive')
          || (!this.sourceFileIds.includes(o.itemId) && o.userPermission >= PermissionTypes.clientFileManager)) {
          return o;
        }
      });
      if (!parentName) {
        this.parentName = iconViewResponse.parentName;
      } else {
        this.parentName = parentName;
      }
      if (this.pageNo === 0) {
        this.iconViewResponse = iconViewResponse;
        this.pageCount = iconViewResponse.pageCount;
      } else {
        this.iconViewResponse.items = [...this.iconViewResponse.items, ...iconViewResponse.items];
      }
      this.fuseSplashScreenService.hide();
    });
    this.parentId = parentId;
    this.selectedItem = null;
  }

  onOkClicked(): boolean {
    const itemParentId = this.data.input.data.parentId;
    if (this.selectedItem) {
      if (itemParentId === this.selectedItem.itemId) {
        this.snackBarService.showError('Can not move item to same folder');
        return false;
      }
      if (!this.canMoveBySelect) {
        this.snackBarService.showError('Please select a folder to move the item');
        return false;
      } else {
        this.data.input.MoveParentToId = this.selectedItem.itemId;
        return true;
      }
    }
    if (!this.canMove) {
      if (itemParentId === this.parentId) {
        this.snackBarService.showError('Can not move item to same folder');
        return false;
      }
      this.snackBarService.showError('Please select a folder to move the item');
      return false;
    }
    this.data.input.MoveParentToId = this.parentId;
    console.log(this.data);
    return true;
  }

  handleAction(type: string, item?: IconViewModel) {
    switch (type) {
      case 'OnBack':
        this.onBack();
        break;
      case 'GoToItem':
        this.goToItem(item);
        break;
      case 'SelectItem':
        this.selectItem(item);
        break;
      default:
        break;
    }
    this.checkValidity();
  }

  goToItem(item: IconViewModel) {
    if (this.parentId === '') {
      this.pageNo = 0;
      this.pageCount = 0;
      if (item.type === 'PersonalDrive') {
        this.getItemList(item.itemId, this.pageNo);
      } else {
        this.getItemList('Team Drives', this.pageNo);
      }
      this.canMove = false;
    } else {
      this.pageNo = 0;
      this.pageCount = 0;
      item.type === 'SharedDrive' ? this.canMove = false : this.canMove = true;
      this.getItemList(item.itemId, this.pageNo);
    }
    this.dialogInfo.okCaption = this.moveHere;
  }

  onBack() {
    this.isClientDrive = true;
    this.pageNo = 0;
    this.dialogInfo.okCaption = this.moveHere;
    if (this.iconViewResponse.parentType === 'Folder') {
      this.canMove = this.iconViewResponse.parentId !== this.iconViewResponse.driveId;
      this.canMove = true;
      this.getItemList(this.iconViewResponse.parentId, this.pageNo);
      return;
    }
    if (this.iconViewResponse.parentId === null) {
      if (this.iconViewResponse.driveType === 'SharedDrives') {
        this.canMove = false;
        this.getItemList('', this.pageNo, 'Orbitax Drive');
      }
      return;
    }
    if (this.iconViewResponse.parentId && this.iconViewResponse.parentId === this.iconViewResponse.driveId) {
      if (this.iconViewResponse.isDefaultDrive) {
        if (this.iconViewResponse.parentType === 'SharedDrives') {
          this.parentName = 'Team Drives';
          this.canMove = false;
          this.getItemList('Team Drives', this.pageNo);
        }
        if (this.iconViewResponse.parentType === 'SharedDrive') {
          this.canMove = false;
          this.getItemList(this.iconViewResponse.parentId, this.pageNo);
        }
      } else if (!this.iconViewResponse.isDefaultDrive) {
        if (this.iconViewResponse.parentType === 'PersonalDrive') {
          this.canMove = false;
          this.getItemList(this.iconViewResponse.parentId, this.pageNo);
        } else {
          this.canMove = false;
          this.getItemList('', this.pageNo, 'Orbitax Drive');
        }
      } else {
        this.canMove = false;
        this.getItemList('', this.pageNo, 'Orbitax Drive');
      }
      return;
    }
  }

  selectItem(item: IconViewModel) {
    if (this.selectedItem === item) {
      this.selectedItem = null;
      this.canMoveBySelect = false;
      this.dialogInfo.okCaption = this.moveHere;
    } else {
      this.dialogInfo.okCaption = this.move;
      this.canMoveBySelect = item.canCopyOrMoveHere;
      this.selectedItem = item;
    }
  }

  onScroll() {
    if (this.pageNo + 1 >= this.pageCount) {
      this.infiniteScrollDisabled = true;
      return;
    }
    this.getItemList(this.parentId, ++this.pageNo);
  }

  private checkValidity() {
    const itemParentId = this.data.input.data.parentId;
    if (this.selectedItem) {
      if (itemParentId === this.selectedItem.itemId) {
        this.dialogInfo.isDisabledOkButton = true;
        return false;
      }
      if (!this.canMoveBySelect) {
        this.dialogInfo.isDisabledOkButton = true;
        return false;
      } else {
        this.dialogInfo.isDisabledOkButton = false;
        return true;
      }
    }
    if (!this.canMove) {
      if (itemParentId === this.parentId) {
        this.dialogInfo.isDisabledOkButton = true;
        return false;
      }
      this.dialogInfo.isDisabledOkButton = true;
      return false;
    }
    this.dialogInfo.isDisabledOkButton = false;
    return true;
  }
}

